import { useState } from "react";
import excel from "../../../../assets/img/svg/buttons/excel.svg";
import { useAppDispatch } from "../../../../hook/useAppDispatch";
import { exportToExcel } from "../../../../store/slice/export-slice";
import Button from "../../Common/Button";
import Modal from "../../Content/HealthMonitor/Modal/Modal";
import { useAppSelector } from "../../../../hook/useAppSelector";
import FallbackLoader from "../../Content/Loader/FallbackLoader";
import info from "../../../../assets/img/svg/modal/info.svg";
import { t } from "i18next";
import { useStatsPayload } from "../../../../hook/useStatsPayload";

interface ExcelProps {
  className?: string;
  filled?: string;
}

const ExportToExcel: React.FC<ExcelProps> = ({ className, filled }) => {
  const dispatch = useAppDispatch();
  const statsPayload = useStatsPayload();
  const loading = useAppSelector((state) => state.export.loading);
  const [openModal, setOpenModal] = useState(false);
  const selectedCurrency = useAppSelector(
    (state) => state.stats.selectedCurrency
  );

  const exportExcel = () => {
    dispatch(exportToExcel({ ...statsPayload, CCY: selectedCurrency }));
    setOpenModal(false);
  };

  return (
    <>
      <Button
        icon={excel}
        onClick={() => setOpenModal(true)}
        variant={filled || "filled"}
        className={className || "excel_button"}
      />
      {loading && <FallbackLoader />}
      {openModal && (
        <Modal
          icon={info}
          modalMessage={t(`statisticPage.header.export.exportExcelMessage`)}
          onConfirm={exportExcel}
          onCancel={() => setOpenModal(false)}
        />
      )}
    </>
  );
};

export default ExportToExcel;
